





























































import { createComponent, ref, onMounted, reactive } from '@vue/composition-api'
import { UnwrapRef } from '@vue/composition-api/dist/reactivity'
import { Table } from 'element-ui'
import { listApproval, ListApprovalParams, ListApproval, operateApproval } from '@/service/public'
import { AccessState, AccessStateLabel } from '@/constant'
interface ConditType {
    pageNum: number
    pageSize: number
    total: number
}

export default createComponent({
    setup() {
        const tableRef = ref<Table>(void null)
        const formInline: UnwrapRef<ListApprovalParams> = reactive({
            dirName: '',
            nameOrId: '',
        })
        const conditions: UnwrapRef<ConditType> = reactive({
            pageNum: 1,
            pageSize: 10,
            total: 0,
        })
        const tableData = ref<ListApproval[]>([])

        const getListApproval = async (current?: number) => {
            let params = {
                current: current || conditions.pageNum,
                size: conditions.pageSize,
                ...formInline,
            }
            const res = await listApproval(params)
            if (res.code === 0 && res.data) {
                tableData.value = res.data.list || []
                conditions.pageNum = res.data.pageNum
                conditions.pageSize = res.data.pageSize
                conditions.total = res.data.total
            } else {
                tableData.value = []
            }
        }
        const changePageSize = (pageSize: number) => {
            conditions.pageSize = pageSize
            getListApproval()
        }
        const setCurrentPage = (currentPage: number) => {
            conditions.pageNum = currentPage
            getListApproval()
        }
        const operate = async (id: string, state: AccessState) => {
            const res = await operateApproval({ id, state })
            if (res.code == 0) {
                getListApproval()
            }
        }

        onMounted(getListApproval)
        return {
            tableRef,
            formInline,
            conditions,
            tableData,
            changePageSize,
            setCurrentPage,
            getListApproval,
            operate,
            AccessState,
            AccessStateLabel,
        }
    },
})
